import { Config } from '@/config';
import { FileInfo, StoredFile } from '@/store/common.interface';
import { Locales } from '@/store/language.interface';
import { getLabel, getTranslation } from '@/utils/data-display-utils';

export const dataURLtoBlob = (dataurl: string): Blob => {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/);
  if (!mime) {
    throw new Error('Invalid MIME type in Data URL');
  }
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime[1] });
};

export const getAltText = (
  file: StoredFile | FileInfo | null,
  defaultTranslationKey: string,
  languageEnabled?: Locales[],
): string => {
  const defaultAltText = getLabel(defaultTranslationKey, languageEnabled);
  if (!file) return defaultAltText;
  const obj = (file as FileInfo).metadata ? (file as FileInfo).metadata.image : file;
  return getTranslation(obj, 'altText', languageEnabled) || defaultAltText;
};

export const getImageUrl = (file?: FileInfo | StoredFile | null): string | null => {
  if (!file?.url) return null;
  if (!(file as FileInfo).metadata?.image) return file.url;
  const image = (file as FileInfo).metadata.image;
  const options = [];
  const url = encodeURIComponent(file.url);
  switch (image.type) {
    case 'crop':
      if (image.coordinates) {
        options.push(`g:nowe:${image.coordinates.left}:${image.coordinates.top}`);
        options.push(`c:${image.coordinates.width}:${image.coordinates.height}`);
      }
      if (image.size) {
        options.push(`s:${image.size.width}:${image.size.height}`);
      }
      break;
    case 'raw':
    default:
      options.push('raw:1');
      break;
  }
  options.push('plain');
  return `${Config.images.url}/_/${options.join('/')}/${url}`;
};
